import { render, staticRenderFns } from "./Difusao.vue?vue&type=template&id=caa2f4a8&"
import script from "./Difusao.vue?vue&type=script&lang=js&"
export * from "./Difusao.vue?vue&type=script&lang=js&"
import style0 from "./Difusao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports